var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine4Cup0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41751 7.95919C2.63781 5.54319 2.74796 4.3352 3.30423 3.41241C3.79355 2.60071 4.5164 1.94077 5.36918 1.52719C6.33867 1.05701 7.55167 1.05701 9.97768 1.05701H26.4383C28.8644 1.05701 30.0774 1.05701 30.9611 1.52719C31.7385 1.94077 32.341 2.60071 32.6823 3.41241C33.0702 4.3352 32.9601 5.54319 32.7398 7.95918L31.2451 24.3518C31.0248 26.7678 30.9146 27.9758 30.3583 28.8986C29.869 29.7103 29.1462 30.3703 28.2934 30.7838C27.3239 31.254 26.1109 31.254 23.6849 31.254H7.22423C4.79822 31.254 3.58521 31.254 2.70147 30.7838C1.92411 30.3703 1.32161 29.7103 0.980324 28.8986C0.592333 27.9758 0.702482 26.7678 0.922779 24.3518L2.41751 7.95919Z",
    fill: "#FFEC19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4875 21.01L12.6493 19.3928L18.4249 7.8877H21.0124L19.8573 18.9539H20.8969L20.689 21.01H19.6263L19.3721 23.5513H16.877L17.1312 21.01H12.4875ZM18.0553 12.5776L15.0519 18.9539H17.4084L18.0784 12.5776H18.0553Z",
    fill: "#08080A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine4Cup0);
export default __webpack_public_path__ + "static/media/line-4-cup-0.14e0bf70a58e51b4fe02de98b54e8360.svg";
export { ForwardRef as ReactComponent };